import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { FormBox, FormFlex, FormGroupAdapter, FormLegend } from 'components/shared/form';

import { SIGNATURE_INITIAL_VALUES, SIGNATURE_CHECKBOX_LABEL_VERSIONS } from 'constants/forms';
import { validateAccepted } from 'utils';

import { LegendFormFlex, StyledTextarea } from '.';

const propTypes = {
  disabled: PropTypes.bool,
  signatureVersion: PropTypes.string,
  acknowledgmentCheckboxesVersion: PropTypes.string,
};

const defaultProps = {
  disabled: true,
  signatureVersion: 'v1',
  acknowledgmentCheckboxesVersion: 'v2',
};

function Waiver({ disabled, signatureVersion, acknowledgmentCheckboxesVersion }) {
  return (
    <Fragment>
      <LegendFormFlex justifyContent="space-between">
        <FormBox>
          <FormLegend>Appraisal/Valuation Disclosure and Waiver:</FormLegend>
        </FormBox>
      </LegendFormFlex>

      <FormFlex>
        <FormBox width={1}>
          <StyledTextarea rows={8} disabled value={SIGNATURE_INITIAL_VALUES[signatureVersion].waiver} />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <Field
            name="application.borrower.waiver"
            type="checkbox"
            label={SIGNATURE_CHECKBOX_LABEL_VERSIONS[acknowledgmentCheckboxesVersion].waiver}
            inlineGroup
            labelOrder={1}
            errorOrder={2}
            disabled={disabled}
            required
            validate={validateAccepted()}
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

Waiver.propTypes = propTypes;
Waiver.defaultProps = defaultProps;

export default Waiver;
